"use client";

import { useLessonPreferences } from "@components/lesson/LessonPreferencesProvider";
import { SpeakingWaveform } from "@ui/LessonFeedback";
import { useTranslations } from "@i18n/provider";

type AnalyzingStateProps = {
  turnCount: number;
};

export function AnalyzingState({ turnCount }: AnalyzingStateProps) {
  const { t } = useTranslations();
  const { reducedMotion } = useLessonPreferences();

  return (
    <div className="flex flex-1 flex-col items-center justify-center gap-4 px-6 py-8 text-center">
      {reducedMotion ? (
        <span className="h-3 w-3 rounded-full bg-speaking" aria-hidden="true" />
      ) : (
        <SpeakingWaveform active />
      )}
      <h3 className="font-display text-base font-semibold text-ink">
        {t("agent.conversation.analyzing.title")}
      </h3>
      <p className="text-sm text-ink-muted">
        {t("agent.conversation.analyzing.turnHint", { count: String(turnCount) })}
      </p>
    </div>
  );
}
